export default function ApproachPillars() {
    const pillars = [
        { n: "01", t: "Diagnostic Baseline", d: "Comprehensive biomarker panels, body composition, and cardio-metabolic mapping. We measure before we recommend." },
        { n: "02", t: "Lifestyle Prescription", d: "Nutrition, movement, sleep, stress and connection — translated into a protocol you can execute on a Tuesday evening." },
        { n: "03", t: "Continuous Recalibration", d: "Wearable signals, fortnightly check-ins, and lab re-tests. Care that adapts to your physiology, not the other way around." },
        { n: "04", t: "Hybrid Delivery", d: "In-clinic precision when it matters; virtual continuity for everything in between. Your care travels with you." },
    ];

    return (
        <section
            className="relative ihx-warm-surface"
            style={{
                backgroundImage:
                    "radial-gradient(60% 80% at 90% 10%, hsl(var(--bg-mist)) 0%, transparent 55%), linear-gradient(180deg, hsl(var(--bg-chalk)) 0%, hsl(var(--bg-stone) / 0.45) 100%)",
            }}
        >
            <div className="ihx-container py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <span className="ihx-eyebrow">The Method</span>
                        <h2 className="ihx-h-section mt-5">
                            A protocol in <span className="ihx-italic">four</span> movements.
                        </h2>
                        <p className="ihx-lead mt-6 max-w-md">
                            Lifestyle and metabolic medicine, practised with the rigour of a tertiary
                            clinic. No fads, no extremes — only what biology and the evidence agree on.
                        </p>
                    </div>

                    <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4">
                        {pillars.map((p) => (
                            <div
                                key={p.n}
                                className="ihx-card p-8 md:p-9"
                            >
                                <div className="flex items-baseline gap-4">
                                    <span className="font-serif italic text-[46px] text-[hsl(var(--brand-gold))] leading-none">
                                        {p.n}
                                    </span>
                                    <span className="font-serif text-[20px] text-[hsl(var(--brand-ink-deep))] leading-tight">
                                        {p.t}
                                    </span>
                                </div>
                                <p className="mt-4 text-[14.5px] leading-[1.7] text-[hsl(var(--ink-soft))]">
                                    {p.d}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
